<script lang="ts">
	import type { Media } from "luxedo-data"
	import { initContextMenu, type ContextMenuOptions } from "context-menu"

	import * as css from "./UserRow.module.css"

	interface Props {
		allMedia: Array<Media>
	}

	let { allMedia }: Props = $props()

	function onMediaClick(media: Media, e: MouseEvent) {
		const mediaType = getMediaTypeName(media)

		const download = async (url: string) => {
			console.warn("NEED TO LOOK MORE INTO THIS ")

			const res = await fetch(url, {
				mode: "cors",
				headers: {
					"Access-Control-Allow-Origin": "*",
				},
			})
			const img = await res.blob()
			const a = document.createElement("a")
			a.href = window.URL.createObjectURL(img)
			a.download = media.name
			a.click()
		}

		const downloadAudioOpt = {
			title: "Download Audio",
			onClick: () => {
				download(media.src.audio)
			},
		}
		const downloadThumbnailOpt = {
			title: "Download Thumbnail",
			onClick: () => download(media.src.thumbnail),
		}

		const mediaImageOpts: ContextMenuOptions = [
			{
				title: "Download Image",
				onClick: () => download(media.src.compressed),
			},
			downloadThumbnailOpt,
		]
		const mediaVideoOpts = [
			{
				title: "Download Video",
				onClick: () => download(media.src.compressed),
			},
			downloadAudioOpt,
			downloadThumbnailOpt,
		]
		const mediaAudioOpts = [downloadAudioOpt]

		let opts
		switch (mediaType) {
			case "Audio":
				opts = mediaAudioOpts
				break
			case "Image":
				opts = mediaImageOpts
				break
			case "Video":
				opts = mediaVideoOpts
				break

			default:
				console.error(`ERROR parsing media type for ${media.name}`, { media })
				break
		}

		const ctxEventHandler = initContextMenu(opts)
		ctxEventHandler(e)
	}

	function getMediaTypeName(media: Media) {
		const generalType = media.mimetype.split("/")[0]
		return `${generalType.charAt(0).toUpperCase()}${generalType.slice(1)}`
	}
</script>

<div class={css.info}>
	<h2>Media</h2>
	{#if allMedia}
		<table>
			<thead>
				<tr>
					<th>ID</th>
					<th>Name</th>
					<th>Type</th>
				</tr>
			</thead>
			<tbody>
				{#each allMedia as media}
					{#if media}
						<tr
							class={css.row}
							onclick={(e) => onMediaClick(media, e)}
							role="button"
							tabindex="0"
						>
							<td>{media.id}</td>
							<td>{media.name}</td>
							<td>{getMediaTypeName(media)}</td>
						</tr>
					{/if}
				{/each}
			</tbody>
		</table>
	{/if}
</div>

<style>
</style>
